/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * The type of resources this ResourceSync manages. Defaults to fleet if not specified.
 */
export enum ResourceSyncType {
  ResourceSyncTypeFleet = 'fleet',
  ResourceSyncTypeCatalog = 'catalog',
}
